import { Notification, ICardReadResult, IWorkingDayCloseResult, IAppEvent, TableSession, OrderRequest, IOrderTicket } from 'app-core';

type Events = {
  appEvent: IAppEvent<any>
  ordersUpdated: undefined
  ordersRefresh: undefined
  showNotification: Notification
  cardReadCompleted: ICardReadResult
  workingDayClosed: IWorkingDayCloseResult
  cancelStornoCompleted: undefined
  /** The sale screen finished a receipt and moves on to the next sale. */
  receiptFinished: undefined
  showConnectionManagement: undefined
  keypad: string
  kitchenTicketUpdated: undefined
  tableSessionsUpdated: undefined
  showSessionPin: { session: TableSession, immediate?: boolean }
  orderRequestPending: OrderRequest
  orderRequestRemoved: undefined
  orderTicketReceived: IOrderTicket
  orderTicketCancelled: IOrderTicket
  orderTicketStatusUpdate: IOrderTicket
  orderTicketError: { externalCode: string, error: string }
  ordersHubAlert: undefined
  tablesViewEnter: undefined
  tablesViewLeave: undefined
  beachFutureDateChanged: boolean
  /** Rows-sheet write landed — the beach floor plan refreshes its row structure. */
  beachRowsUpdated: undefined
}

type EventNames = keyof Events;
type EventCallback<T> = (payload: T) => void;

export interface Emitter {
  listeners: Map<EventNames, Function[]>;
  on: <K extends EventNames>(event: K, listener: EventCallback<Events[K]>) => void;
  off: <K extends EventNames>(event: K, listener: EventCallback<Events[K]>) => void;
  emit: <K extends EventNames>(event: K, payload?: Events[K]) => void;
}

export const emitter: Emitter = {
  listeners: new Map(),
  on(event, listener) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, [])
    }
    this.listeners.get(event)?.push(listener)
  },
  off(event, listener) {
    const listeners = this.listeners.get(event)
    if (!listeners) return
    const index = listeners.indexOf(listener)
    if (index !== -1) listeners.splice(index, 1)
  },
  emit(event, payload) {
    if (this.listeners.has(event)) {
      const listeners = this.listeners.get(event)
      listeners?.forEach((listener: Function) => listener(payload))
    }
  }
}
